import { render, staticRenderFns } from "./Favoritos.vue?vue&type=template&id=c8c38df8&scoped=true"
import script from "./Favoritos.vue?vue&type=script&lang=js"
export * from "./Favoritos.vue?vue&type=script&lang=js"
import style0 from "./Favoritos.vue?vue&type=style&index=0&id=c8c38df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c38df8",
  null
  
)

export default component.exports